import GLightbox from 'glightbox'

export function lightbox() {
	const lightbox = GLightbox({
		touchNavigation: true,
		loop: true,
		autoplayVideos: false,
		openEffect: 'fade',
		closeEffect: 'fade',
	})
}
